import React from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import BasePage from 'apps/auth/components/utils/BasePage';
import { INCREASE_LIMITS_CONTINUE_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { GT_LEVEL } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { AUTH_PROFILE_GT_AML_LEVEL } from 'apps/auth/constants/UrlConstants';
import { resolveArguments } from 'apps/auth/helpers/utils';

const ProfileGTAmlLevelInfoPage = (props) => {
    const expectedGTLevel = props.current_limit + 1;
    return (
        <BaseLayout showChat={false}>
            <InfoPage
                iconName="zap-80"
                iconColor="primary"
                headerText={
                    <>
                        <span className="color-GT">{resolveArguments(props.profilePurpleBlock, props.aml_level_name)}</span>&nbsp;
                        {props.increase_block}
                    </>
                }
                secondaryText={<DangerouslyHtml dangerouslyHtml={props.increase_sub_block} />}
                topButtonCaption={props.notificationButton}
                topButtonType="link"
                topButtonLink={props.notNowLink}
                primaryButtonCaption={props.nextButton}
                primaryButtonType="link"
                primaryButtonLink={`${AUTH_PROFILE_GT_AML_LEVEL}/${props.current_limit}/docs`}
                primaryButtonOnClick={() => {
                    amplitude.getInstance().logEvent(INCREASE_LIMITS_CONTINUE_CLICKED, { [GT_LEVEL]: expectedGTLevel });
                }}
            />
        </BaseLayout>
    );
};
const mapStateToProps = (state) => {
    return {
        aml_level_name: state.messages.pageMessages.aml_level_name,
        increase_block: state.messages.pageMessages.increase_block,
        increase_sub_block: state.messages.pageMessages.increase_sub_block,
        nextButton: state.messages.pageMessages.nextButton,
        notificationButton: state.messages.pageMessages.notificationButton,
        profilePurpleBlock: state.messages.pageMessages.profilePurpleBlock,
        current_limit: state.extra.current_limit,
        notNowLink: state.extra.notNowLink,
    };
};
export default connect(mapStateToProps)(BasePage(ProfileGTAmlLevelInfoPage));
